import React from 'react'
import DoctorHeader from './DoctorHeader'
import DoctorSideBar from './DoctorSideBar'
const DoctorEditProfile = () => {
  return (
    <>
    <DoctorHeader/>
    <DoctorSideBar />
    </>
  )
}

export default DoctorEditProfile
